<div
    #editorRef
    class="h-full *:h-full *:outline-none"
    [style]="{ minHeight: minHeight + 'px' }"
    (click)="editor?.commands.focus()"
></div>
